import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

class BoatSVG extends ApplicationComponent {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 33 13"
        x={this.props.x}
        y={this.props.y}
        className={this.props.className}
        style={this.props.style}
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        onClick={this.props.onClick}
      >
        <path d="M1.26134 5.67431C5.36652 2.63006 8.42202 1.51923 14.2322 0.831543L16.2322 0.831543C16.7845 0.831543 17.2322 1.27926 17.2322 1.83154L17.2322 11.0883C17.2322 11.6406 16.7845 12.0883 16.2322 12.0883L14.2322 12.0883C8.5046 11.3236 5.4444 10.2495 1.271 7.2327C0.740654 6.84932 0.735691 6.06411 1.26134 5.67431Z" />
        <path d="M16.2322 0.831543L16.2322 12.0883L31.2222 12.0883C31.7744 12.0883 32.2222 11.6406 32.2222 11.0883L32.2222 1.83154C32.2222 1.27926 31.7744 0.831543 31.2222 0.831543L16.2322 0.831543Z" />
      </svg>
    )
  }
}

BoatSVG.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  x: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  y: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
}

export default BoatSVG
